import Restful from '../utils/restful.js'
import http from '../utils/http.js'
const project = 'sci/'

const role = new Restful(project, 'role')

role.getAuthority = function(id) {
  const url = project + 'role/' + id + '/authority'
  return http.get(url).then(res => {
    return res
  })
}

role.setAuthority = function(id, authorityIds) {
  const url = project + 'role/' + id + '/authority'
  return http.put(url, authorityIds).then(res => {
    return res
  })
}

role.addJournal = function(data){
  const url = project + 'role/journal'
  return http.post(url, data).then(res => {
    return res
  })
}
export default role
